













import Vue from 'vue'
import AppHeader from './components/AppHeader.vue'
import AppIntro from './components/AppIntro.vue'
import AppCompare from './components/AppCompare.vue'
import AppSoftware from './components/AppSoftware.vue'
import AppAside from './components/AppAside.vue'
import AppTwoUp from './components/AppTwoUp.vue'
import AppConclusion from './components/AppConclusion.vue'
import AppFooter from './components/AppFooter.vue'

const emergence = require('emergence.js')

export default Vue.extend({
  name: 'app',

  components: {
    AppHeader,
    AppIntro,
    AppCompare,
    AppSoftware,
    AppAside,
    AppTwoUp,
    AppConclusion,
    AppFooter
  },

  mounted() {
    emergence.init()
  }
})
